/**
 * Mixin to watch scroll on "content" element
 * or on specific elements
 */

export default function(id = "content") {
  return {
    data() {
      return {
        watchedElement: null,
        scrollPositionTop: null,
        scrollPositionBottom: null
      };
    },

    methods: {
      _onContentScroll(e) {
        this.scrollPositionTop = e.target.scrollTop;
        this.scrollPositionBottom =
          e.target.scrollHeight - this.scrollPositionTop;
      }
    },

    mounted() {
      this.watchedElement = document.getElementById(id);
      this.watchedElement.addEventListener("scroll", this._onContentScroll);
    },

    beforeDestroy() {
      this.watchedElement.removeEventListener("scroll", this._onContentScroll);
    }
  };
}
